export default __webpack_public_path__ + "static/media/Tooltip.bb6e8a93.svg";